import { IModuleTranslation } from '@larscom/ngx-translate-module-loader';

const baseTranslateUrl = './assets/i18n/tracker/type/heart-rate';
const moduleName = 'tracker-type-heart-rate';

export const trackerTypeHeartRate: Array<IModuleTranslation> = [
  {
    baseTranslateUrl,
    moduleName,
    pathTemplate: '{baseTranslateUrl}/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-chart`,
    pathTemplate: '{baseTranslateUrl}/chart/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-filter`,
    pathTemplate: '{baseTranslateUrl}/filter/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-goal`,
    pathTemplate: '{baseTranslateUrl}/goal/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-latest`,
    pathTemplate: '{baseTranslateUrl}/latest/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-overview`,
    pathTemplate: '{baseTranslateUrl}/overview/{language}'
  }
];
